"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const importModule_1 = __importDefault(require("./importModule"));
const messagesMap_1 = __importDefault(require("./messagesMap"));
const unbindModule_1 = __importDefault(require("./binding/unbindModule"));
const inversify_1 = require("inversify");
const inversifySugarOptions_1 = __importStar(require("./inversifySugarOptions"));
const middlewares_1 = require("../middlewares");
/**
 * @description InversifySugar is a utility class that helps you to bootstrap inversify and configure it.
 */
class InversifySugar {
    static get globalContainer() {
        return InversifySugar.state.globalContainer;
    }
    /**
     * @description This method is used to bootstrap inversify and import the AppModule.
     */
    static run(AppModule) {
        if (InversifySugar.state.isRunning) {
            throw new Error(messagesMap_1.default.alreadyRunning);
        }
        InversifySugar.state.isRunning = true;
        InversifySugar.state.rootModule = AppModule;
        (0, importModule_1.default)(AppModule, true);
    }
    /**
     * @description This method is used to reset the options and state of the dependency system.
     * It is useful for testing purposes.
     */
    static reset() {
        return __awaiter(this, void 0, void 0, function* () {
            InversifySugar.state.rootModule &&
                (yield (0, unbindModule_1.default)(InversifySugar.state.rootModule));
            yield InversifySugar.globalContainer.unbindAllAsync();
            Object.assign(InversifySugar.state, {
                isRunning: false,
                rootModule: undefined,
            });
            Object.assign(InversifySugar.options, inversifySugarOptions_1.defaultInverseSugarOptions);
        });
    }
    static onModuleBinded(container, metadata, Module) {
        var _a;
        (_a = inversifySugarOptions_1.default.onModuleBinded) === null || _a === void 0 ? void 0 : _a.call(inversifySugarOptions_1.default, container, metadata, Module);
        if (inversifySugarOptions_1.default.debug) {
            console.log(messagesMap_1.default.moduleProvidersBinded(Module.name));
        }
    }
    static setOnModuleBinded(value) {
        inversifySugarOptions_1.default.onModuleBinded = value;
    }
}
exports.default = InversifySugar;
InversifySugar.state = {
    isRunning: false,
    globalContainer: new inversify_1.Container(),
    rootModule: undefined,
};
InversifySugar.options = inversifySugarOptions_1.default;
InversifySugar.globalContainer.applyMiddleware(middlewares_1.loggerMiddleware);
